import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5648aaac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-6 px-10" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "bg-white p-6 rounded-2xl mt-6"
}
const _hoisted_5 = { class: "flex flex-col items-center justify-center gap-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500 text-sm" }, "При получении периода произошла ошибка", -1))
const _hoisted_7 = {
  key: 2,
  class: "text-sm"
}
const _hoisted_8 = {
  key: 1,
  class: "bg-white p-6 rounded-2xl mt-6"
}
const _hoisted_9 = { class: "border p-6 rounded-2xl" }
const _hoisted_10 = { class: "flex items-center justify-between" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center gap-5\" data-v-5648aaac><svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-5648aaac><g clip-path=\"url(#clip0_3582_4843)\" data-v-5648aaac><path d=\"M13.5 3V3.5H0.5V3C0.5 2.173 1.173 1.5 2 1.5H2.5V1C2.5 0.7235 2.724 0.5 3 0.5C3.276 0.5 3.5 0.7235 3.5 1V1.5H6.5V1C6.5 0.7235 6.724 0.5 7 0.5C7.276 0.5 7.5 0.7235 7.5 1V1.5H10.5V1C10.5 0.7235 10.724 0.5 11 0.5C11.276 0.5 11.5 0.7235 11.5 1V1.5H12C12.827 1.5 13.5 2.173 13.5 3ZM15.5 12C15.5 13.9325 13.933 15.5 12 15.5C10.067 15.5 8.5 13.9325 8.5 12C8.5 10.0675 10.067 8.5 12 8.5C13.933 8.5 15.5 10.0675 15.5 12ZM14 12C14 11.7235 13.776 11.5 13.5 11.5H12.5V10.5C12.5 10.2235 12.276 10 12 10C11.724 10 11.5 10.2235 11.5 10.5V12C11.5 12.2765 11.724 12.5 12 12.5H13.5C13.776 12.5 14 12.2765 14 12ZM13.5 4.5V7.76C13.03 7.59 12.525 7.5 12 7.5C9.52 7.5 7.5 9.52 7.5 12C7.5 12.525 7.59 13.03 7.76 13.5H2C1.175 13.5 0.5 12.825 0.5 12V4.5H13.5ZM5 11C5 10.7235 4.776 10.5 4.5 10.5H3.5C3.224 10.5 3 10.7235 3 11C3 11.2765 3.224 11.5 3.5 11.5H4.5C4.776 11.5 5 11.2765 5 11ZM5 9C5 8.7235 4.776 8.5 4.5 8.5H3.5C3.224 8.5 3 8.7235 3 9C3 9.2765 3.224 9.5 3.5 9.5H4.5C4.776 9.5 5 9.2765 5 9ZM5 7C5 6.7235 4.776 6.5 4.5 6.5H3.5C3.224 6.5 3 6.7235 3 7C3 7.2765 3.224 7.5 3.5 7.5H4.5C4.776 7.5 5 7.2765 5 7ZM8 7C8 6.7235 7.776 6.5 7.5 6.5H6.5C6.224 6.5 6 6.7235 6 7C6 7.2765 6.224 7.5 6.5 7.5H7.5C7.776 7.5 8 7.2765 8 7Z\" fill=\"#3B82F6\" data-v-5648aaac></path></g><defs data-v-5648aaac><clipPath id=\"clip0_3582_4843\" data-v-5648aaac><rect width=\"16\" height=\"16\" fill=\"white\" data-v-5648aaac></rect></clipPath></defs></svg><div class=\"text-sm font-semibold uppercase\" data-v-5648aaac>Период</div></div>", 1)
const _hoisted_12 = { class: "border p-6 rounded-2xl mt-5" }
const _hoisted_13 = { class: "flex items-center justify-between" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center gap-5\" data-v-5648aaac><svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-5648aaac><g clip-path=\"url(#clip0_4329_3061)\" data-v-5648aaac><path d=\"M4.01148 8.48633H3.29395C3.10571 8.48633 2.93579 8.59839 2.86133 8.771L0.875 13.3961L5.59229 10.9868C5.02759 10.2054 4.46887 9.34363 4.01148 8.48633Z\" fill=\"#3B82F6\" data-v-5648aaac></path><path d=\"M13.1386 8.771C13.0642 8.59839 12.8942 8.48633 12.7061 8.48633H11.9885C11.1248 10.105 9.86633 11.7777 9.0658 12.698C8.50281 13.3438 7.49719 13.343 6.93506 12.698C6.87756 12.632 6.57739 12.2844 6.16394 11.75L5.31348 12.1846L8.53052 15.3954L14.6262 12.2352L13.1386 8.771Z\" fill=\"#3B82F6\" data-v-5648aaac></path><path d=\"M0.295042 14.7482L0.0384505 15.3457C-0.094362 15.6549 0.133177 16.0002 0.470946 16.0002H7.37878C7.422 15.9681 7.42248 15.9701 7.65442 15.8499L4.43262 12.6348L0.295042 14.7482Z\" fill=\"#3B82F6\" data-v-5648aaac></path><path d=\"M15.9619 15.3459L14.998 13.1016L9.40625 16.0005H15.5294C15.8665 16.0005 16.095 15.6558 15.9619 15.3459Z\" fill=\"#3B82F6\" data-v-5648aaac></path><path d=\"M8.47046 4.22937C8.47046 3.97034 8.25928 3.75977 7.99988 3.75977C7.74036 3.75977 7.5293 3.97034 7.5293 4.22937C7.5293 4.48828 7.74036 4.69897 7.99988 4.69897C8.25928 4.69897 8.47046 4.48828 8.47046 4.22937Z\" fill=\"#3B82F6\" data-v-5648aaac></path><path d=\"M8.35486 12.0506C8.51331 11.8687 12.2349 7.56373 12.2349 4.6045C12.2349 -1.49755 3.76465 -1.57201 3.76465 4.6045C3.76465 7.56373 7.48621 11.8687 7.64465 12.0506C7.83228 12.2658 8.1676 12.2655 8.35486 12.0506ZM6.58801 4.22889C6.58801 3.45204 7.22131 2.82008 7.99976 2.82008C8.77808 2.82008 9.41138 3.45204 9.41138 4.22889C9.41138 5.00563 8.77808 5.63759 7.99976 5.63759C7.22131 5.63759 6.58801 5.00563 6.58801 4.22889Z\" fill=\"#3B82F6\" data-v-5648aaac></path></g><defs data-v-5648aaac><clipPath id=\"clip0_4329_3061\" data-v-5648aaac><rect width=\"16\" height=\"16\" fill=\"white\" data-v-5648aaac></rect></clipPath></defs></svg><div class=\"text-sm font-semibold uppercase\" data-v-5648aaac>География</div></div>", 1)
const _hoisted_15 = { class: "mt-5" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Укажите сектор действия данного периода", -1))
const _hoisted_17 = {
  key: 0,
  class: "mt-5 flex flex-col items-center justify-center gap-4"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500 text-sm" }, "При получении секторов произошла ошибка", -1))
const _hoisted_19 = {
  key: 2,
  class: "text-sm"
}
const _hoisted_20 = {
  key: 1,
  class: "mt-5 grid grid-cols-3 gap-x-3 gap-y-5 overflow-hidden overflow-y-auto max-h-96 pr-2"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "mt-10 flex items-center justify-end gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_the_input = _resolveComponent("the-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Редактировать период" }),
      _createVNode(_component_router_link, { to: "/time-slots/periods" }, {
        default: _withCtx(() => [
          _createVNode(_component_the_button, { class: "small second text" }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" Назад ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (_ctx.data_state.period.is_loading || _ctx.data_state.period.is_loading || !_ctx.data_state.period.item)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.data_state.period.is_loading)
              ? (_openBlock(), _createBlock(_component_Loader, {
                  key: 0,
                  class: "primary"
                }))
              : (_ctx.data_state.period.is_failed)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_6,
                    _createVNode(_component_the_button, {
                      type: "button",
                      class: "primary small",
                      onClick: _ctx.loadPeriod
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Обновить")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 64))
                : (!_ctx.data_state.period.item)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Нет периода"))
                  : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_checkbox, {
                label: "Активен",
                value: _ctx.state.is_active,
                onChange: _ctx.onToggleStatus
              }, null, 8, ["value", "onChange"])
            ]),
            _createVNode(_component_the_input, {
              class: "mt-5",
              placeholder: "Наименование",
              value: _ctx.state.name,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.name) = $event)),
              disabled: _ctx.state.is_loading || _ctx.data_state.period.is_loading,
              "is-invalid": _ctx.state_form$.name.$error,
              "validation-errors": _ctx.state_form$.name.$errors
            }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              (_ctx.data_state.sectors.list.length > 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "flex items-center p-3 border rounded cursor-pointer",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSelectAllSectors && _ctx.onSelectAllSectors(...args)))
                  }, [
                    _createVNode(_component_checkbox, {
                      label: "Выбрать все",
                      disabled: _ctx.state.is_loading || _ctx.data_state.period.is_loading,
                      value: _ctx.isAllSectorsSelected
                    }, null, 8, ["disabled", "value"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              (_ctx.data_state.sectors.is_loading || _ctx.data_state.sectors.is_failed || _ctx.data_state.sectors.list.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    (_ctx.data_state.sectors.is_loading)
                      ? (_openBlock(), _createBlock(_component_Loader, {
                          key: 0,
                          class: "primary"
                        }))
                      : (_ctx.data_state.sectors.is_failed)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_18,
                            _createVNode(_component_the_button, {
                              type: "button",
                              class: "primary small",
                              onClick: _ctx.loadSectors
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Обновить")
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ], 64))
                        : (_ctx.data_state.sectors.list.length === 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_19, "Список пуст"))
                          : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data_state.sectors.list, (sector) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: sector.id,
                        class: "flex items-center p-3 border rounded cursor-pointer",
                        onClick: ($event: any) => (_ctx.onSelectSector(sector.id))
                      }, [
                        _createVNode(_component_checkbox, {
                          label: sector.name,
                          disabled: _ctx.isSectorSaved(sector.id),
                          value: _ctx.isSectorSelected(sector.id)
                        }, null, 8, ["label", "disabled", "value"])
                      ], 8, _hoisted_21))
                    }), 128))
                  ]))
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_the_button, {
              disabled: _ctx.data_state.period.is_loading,
              loading: _ctx.state.is_loading,
              class: "small primary",
              onClick: _ctx.onSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode("Сохранить")
              ]),
              _: 1
            }, 8, ["disabled", "loading", "onClick"])
          ])
        ]))
  ]))
}